__turbopack_context__.v({
  "card": "jetPricing-module-scss-module__7otRCa__card",
  "cardHeader": "jetPricing-module-scss-module__7otRCa__cardHeader",
  "cardImg": "jetPricing-module-scss-module__7otRCa__cardImg",
  "cardImgWrapper": "jetPricing-module-scss-module__7otRCa__cardImgWrapper",
  "cardPriceTitle": "jetPricing-module-scss-module__7otRCa__cardPriceTitle",
  "cardPriceWrapper": "jetPricing-module-scss-module__7otRCa__cardPriceWrapper",
  "cardTitle": "jetPricing-module-scss-module__7otRCa__cardTitle",
  "cardWrapper": "jetPricing-module-scss-module__7otRCa__cardWrapper",
  "plainName": "jetPricing-module-scss-module__7otRCa__plainName",
});
